import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const slideUp = keyframes`from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; }`;
const rotate = keyframes`from { transform: rotate(0deg); } to { transform: rotate(360deg); }`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(8px);
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  animation: ${fadeIn} 0.3s ease;
`;

export const Container = styled.div`
  background: #fff;
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
  animation: ${slideUp} 0.4s ease-out;
  overflow: hidden;
`;

export const Header = styled.div`
  padding: 20px 30px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  h2 {
    font-size: 1.4rem;
    margin: 0;
    color: #111;
    span {
      color: #d4af37;
    }
  }
`;

export const CloseBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  transition: color 0.2s;
  &:hover {
    color: #ff4d4d;
  }
`;

export const Body = styled.div`
  padding: 30px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 25px;
`;

// --- SEÇÃO DE BUSCA ---
export const SearchSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SearchBar = styled.div`
  display: flex;
  gap: 10px;
  input {
    flex: 1;
    height: 50px;
    border-radius: 12px;
    border: 1px solid #ddd;
    padding: 0 15px;
    font-size: 1rem;
    transition: border-color 0.2s;
    &:focus {
      outline: none;
      border-color: #d4af37;
    }
  }
`;

export const SearchBtn = styled.button`
  width: 55px;
  background: #111;
  color: #fff;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  &:hover:not(:disabled) {
    background: #333;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .spinning {
    animation: ${rotate} 1s linear infinite;
  }
`;

export const ResultsList = styled.div`
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 12px;
  background: #fafafa;
  margin-top: 5px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);
`;

export const ResultItem = styled.div`
  padding: 12px 18px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.2s;
  &:hover {
    background: #fdfbf0;
  }
  .name {
    font-weight: 600;
    color: #333;
  }
  .cpf {
    font-size: 0.85rem;
    color: #777;
    font-family: monospace;
  }
  &:last-child {
    border: none;
  }
`;

export const SearchLoadingText = styled.div`
  padding: 20px;
  text-align: center;
  color: #888;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

// --- CARDS E INPUTS ---
export const Card = styled.div`
  background: #fff;
  border: 1px solid #eee;
  border-radius: 18px;
  padding: 20px;
`;

export const SelectedClientBox = styled.div`
  background: #fdfbf0;
  border: 1px solid #f7e08b;
  padding: 18px;
  border-radius: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  animation: ${fadeIn} 0.3s ease;
  .info {
    strong {
      display: block;
      font-size: 1.05rem;
    }
    span {
      font-size: 0.85rem;
      color: #666;
    }
  }
`;

export const ModeGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-top: 10px;
`;

export const ModeOption = styled.div`
  padding: 18px;
  border-radius: 15px;
  text-align: center;
  cursor: pointer;
  border: 2px solid ${(props) => (props.active ? "#d4af37" : "#f3f4f6")};
  background: ${(props) => (props.active ? "#fffdf5" : "#fff")};
  transition: 0.2s;
  strong {
    display: block;
    font-size: 0.95rem;
    margin-bottom: 4px;
    color: ${(props) => (props.active ? "#111" : "#555")};
  }
  small {
    font-size: 0.75rem;
    color: #888;
  }
  &:hover {
    border-color: #d4af37;
  }
`;

export const InputGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 18px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  label {
    font-size: 0.8rem;
    font-weight: 700;
    color: #666;
    text-transform: uppercase;
  }
  input {
    height: 50px;
    border-radius: 12px;
    border: 1px solid #ddd;
    padding: 0 15px;
    font-size: 1rem;
    transition: all 0.2s;
    &:focus {
      outline: none;
      border-color: #d4af37;
      box-shadow: 0 0 0 4px rgba(212, 175, 55, 0.1);
    }
  }
`;

export const Footer = styled.div`
  padding: 25px 30px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  background: #fdfdfd;
`;

export const SubmitBtn = styled.button`
  background: #d4af37;
  color: #000;
  border: none;
  padding: 0 40px;
  height: 54px;
  border-radius: 14px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: 0.3s ease;
  &:hover:not(:disabled) {
    background: #c5a02d;
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(212, 175, 55, 0.2);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  margin-top: 18px;
  font-weight: 600;
  font-size: 0.9rem;
  color: #444;
  user-select: none;
`;
